// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ccc-box-plot{background:#fff;border-radius:7px;position:fixed;top:50%;left:50%;transform:translate(-50%, -50%)}.ccc-box-plot__title{color:#1E2B4E;font-size:1.5rem;text-align:center;margin-bottom:1.5rem;padding:3rem 0}.ccc-box-plot .highcharts-container{margin:0 auto;overflow-y:auto}.ccc-box-plot .highcharts-scrolling-parent{display:flex;justify-content:center}.ccc-box-plot .highcharts-scrolling{z-index:0}.highcharts-tooltip-container{z-index:1000 !important}\n", ""]);
// Exports
module.exports = exports;
